import '.h{display:flex;}.ssr-plugin'
import '.a5{flex-direction:row;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.br{flex-grow:1;}.ssr-plugin'
import '.j{align-items:center;}.ssr-plugin'
import '.l{justify-content:center;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.bc{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.a9{align-items:stretch;}.ssr-plugin'
import '.bd{margin-top:2rem;}.ssr-plugin'
import '.b8{margin-bottom:5rem;}.ssr-plugin'
import '.b7{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <div className="h a5 ac"
      >
        <InitiativeSideBar />
        <div className="br h j l i"
          style={{
            marginLeft: isMobile ? '3.25rem' : '14rem', // left bar
          }}
        >
          <DashboardNavBar
            initiativeDashboard={true}
            style={{ backgroundColor: 'var(--shades-white)' }}
          />
          <div className="bc h i a9 bd b8 b7"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '60%', // 12rem is padding + navbar height
              paddingInline: isMobile ? '1rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
